import { render, staticRenderFns } from "./wizard.vue?vue&type=template&id=3161579a&scoped=true"
import script from "./wizard.vue?vue&type=script&lang=js"
export * from "./wizard.vue?vue&type=script&lang=js"
import style0 from "./wizard.vue?vue&type=style&index=0&id=3161579a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3161579a",
  null
  
)

export default component.exports